import { makeStyles, Theme } from '@material-ui/core';
import { PrimaryButton } from 'src/components/ui/Buttons';
import { Card, CardContent, CardHeader } from 'src/components/ui/card';
import { Add } from '@material-ui/icons';
import { Text } from 'src/components/ui/typography/Text';
import { TagsDrawerStatus } from './AnalysisPage';

interface NoChartsProps {
  setIsDrawerOpen: (tagsDrawerStatus: TagsDrawerStatus) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
  },
  title: {
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  message: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  noPaddingTop: {
    '&.MuiCardContent-root': {
      paddingTop: 0,
    },
  },
}));

const NoCharts: React.FC<NoChartsProps> = ({ setIsDrawerOpen }) => {
  const classes = useStyles();

  const handleOpenDrawer = () => {
    setIsDrawerOpen({ isOpen: true, viewId: null, chartId: null });
  };

  return (
    <Card>
      <CardHeader>
        <Text className={classes.title} fontFamily="mono" fontSize={12}>
          Chart 1 of 1
        </Text>
      </CardHeader>
      <CardContent className={classes.noPaddingTop}>
        <Card>
          <CardContent>
            <div className={classes.root}>
              <Text className={classes.message}>Add a Point to start populating this chart.</Text>
              <PrimaryButton startIcon={<Add />} onClick={handleOpenDrawer}>
                Add Point
              </PrimaryButton>
            </div>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
};

export default NoCharts;
